import { FiltroPersonamast } from './../../../../core/personamast/dominio/FiltroPersonamast';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { PersonamastSelectorComponent } from 'src/app/erp/core/personamast/vista/selector/personamastselector.component';
import { SelectItem, MessageService } from 'primeng/api';
import { FiltroCoDocumentoCobrar } from '../../dominio/FiltroCoDocumentoCobrar';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { CoDocumentoServicio } from '../../service/codocumento.service';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { LazyLoadEvent } from 'primeng/primeng';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ViewChild, ChangeDetectorRef, OnInit } from '@angular/core';
import { PersonamastServicio } from 'src/app/erp/core/personamast/service/personamast.service';
import { Table } from 'primeng/table';

@Component({
    templateUrl: './letra-listado.component.html'
})

export class LetralistadoComponent extends PrincipalBaseComponent implements OnInit {

    PG_DOCUMENTOS_LISTAR: number = 0;
    PG_CLIENTE_SELECTOR: number = 3;

    PG_ACTUAL: number = 0;

    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;

    lstEstados: SelectItem[] = [];
    lstEstadosLetras: SelectItem[] = [];
    filtro: FiltroCoDocumentoCobrar = new FiltroCoDocumentoCobrar();
    seleccionados: any[] = [];
    cargando: boolean = true;
    montoTotal: number;

    filtroCancelar: FiltroPersonamast = new FiltroPersonamast();

    checked: boolean = true;
    noChecked: boolean = true;
    verCancelar: boolean = false;
    filtrofechas: Boolean = false;
    lstClientes: any[];
    dtoPersonamast: DtoPersonamast = new DtoPersonamast();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private coDocumentoServicio: CoDocumentoServicio,
        private cdref: ChangeDetectorRef,
        private personamastServicio: PersonamastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();
    @ViewChild(Table,{static:false}) dt: Table;

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }
    captureId(event: any) {
        this.dtoPersonamast.busqueda = event.busqueda;
        this.dtoPersonamast.persona = event.persona;
    }

    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }


    ngOnInit() {
        super.ngOnInit();
        const cliente = JSON.parse(this.route.snapshot.params['cliente']) as DtoPersonamast;

        this.cargarEstados();
        this.filtro.conAceptada = 'N';

        if (cliente.accion === undefined) {
            const filtro = JSON.parse(this.route.snapshot.params['filtro']) as FiltroPersonamast;
            if (cliente != null) {
                this.dtoPersonamast.busqueda = cliente.busqueda;
                this.dtoPersonamast.persona = cliente.persona;
                this.filtro.desde = null;
                this.filtro.hasta = null;
                this.verCancelar = true;
                this.filtroCancelar = filtro;
            }
        } else {
            this.filtro.idVendedor = cliente.vendedor;
            this.filtro.conAceptada = cliente.conAceptada;
            this.filtro.desde = cliente.desde;
            this.filtro.hasta = cliente.hasta;
            this.cargando = false;
        }
    }

    toggleVisibility(e) {
        if (e) {
            this.filtro.desde = new Date();
            this.filtro.hasta = new Date();
        } else {
            this.filtro.desde = null;
            this.filtro.hasta = null;
        }
    }

    cargarCliente(bean: DtoPersonamast) {
        this.filtro.cliente = bean.persona;
        this.filtro.nombreCliente = bean.busqueda;
        this.cargando = true;
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }

    cargarEstados() {
        this.bloquearPagina();

        this.lstEstadosLetras.push({ label: 'Todo estado de Letras', value: null });
        this.coDocumentoServicio.listarEstadoLetras().then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstadosLetras.push({ label: reg.descripcionLocal, value: reg.letraEstado.trim() });
                    }
                );

            }
        );

        this.lstEstados.push({ label: 'TODO ESTADO', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'DOCUEST').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.filtro.conVencidos = true;
                this.cargando = false;
                this.desbloquearPagina();
            }
        );

    }

    cancelarAccionSelector() {
        this.cargando = true;
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }

    cargarPaginacion(event: LazyLoadEvent) {

        if (this.cargando) {
            return;
        }

        this.cargando = true;

        this.bloquearPagina();

        if (this.filtro.hasta != null && this.filtro.desde != null) {
            if (this.filtro.desde > this.filtro.hasta) {
                this.mostrarMensajeAdvertencia('La fecha hasta debe se mayor o igual que la fecha desde');
                this.desbloquearPagina();
                return;
            }
        }

        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;
        this.filtro.cliente = this.dtoPersonamast.persona;
        this.filtro.nombreCliente = this.dtoPersonamast.busqueda;
        this.montoTotal = 0;
        this.coDocumentoServicio.listarLetraPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.filtro.paginacion.listaResultado.forEach(item => {
                    this.montoTotal = this.montoTotal + item.montoTotal;
                });
                this.desbloquearPagina();
            });
    }

    buscar() {
        if (this.filtrofechas === false) {
            if (this.estaVacio(this.dtoPersonamast.persona) && this.estaVacio(this.filtro.numero)) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de letra');
                return;
            } else if (this.dtoPersonamast.persona === undefined && this.filtro.numero === undefined) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de letra');
                return;
            }
        }

        if (this.filtrofechas === false) {
            this.filtro.desde = null;
            this.filtro.hasta = null;

            if (this.filtro.desde != null && this.filtro.hasta != null) {
                if (this.filtro.desde > this.filtro.hasta) {
                    this.mostrarMensajeAdvertencia('La fecha de Fin debe se mayor o igual que la fecha de Inicio');
                    this.desbloquearPagina();
                    return;
                }
            }

        }
        this.cargando = false;
        this.dt.reset();
    }

    cancelar() {
        this.router.navigate(['/royal/cliente-listado', '_', JSON.stringify(this.filtroCancelar)], { skipLocationChange: true });
    }

}



